export const TickIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6671 7.38625V7.99958C14.6663 9.4372 14.2007 10.836 13.34 11.9875C12.4792 13.1389 11.2693 13.9812 9.89065 14.3889C8.51203 14.7965 7.03858 14.7475 5.69005 14.2493C4.34153 13.7511 3.19018 12.8303 2.40771 11.6243C1.62525 10.4183 1.2536 8.99163 1.34819 7.55713C1.44278 6.12263 1.99854 4.75714 2.93259 3.6643C3.86664 2.57146 5.12893 1.80984 6.5312 1.49301C7.93347 1.17619 9.40059 1.32114 10.7137 1.90625"
      stroke="#262626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 2.66699L8 9.34033L6 7.34033"
      stroke="#262626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
